import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Separator } from '../components/ui/separator';

const Tools = () => {
  return (
    <div className="min-h-screen bg-slate-50/50 flex flex-col">
      {/* Header with enhanced styling */}
      <div className="bg-sidebar sticky top-0 z-10">
        <div className="flex h-[73px] items-center justify-between px-8">
          <div className="space-y-1">
            <h1 className="text-2xl font-bold text-card-foreground tracking-tight">Tools</h1>
          </div>
        </div>
      </div>
      <Separator className="w-full" />

      <div className="flex-1 px-8 py-8 space-y-8">
        {/* Main content */}
        <Card className="border border-slate-200 bg-white shadow-none">
          <CardContent className="p-12 text-center">
            <div className="max-w-md mx-auto space-y-4">
              <div className="w-16 h-16 bg-slate-100 flex items-center justify-center mx-auto">
                <svg className="w-8 h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-card-foreground">
                Tools Coming Soon
              </h2>
              <p className="text-muted-foreground">
                This page is under construction. Tools and utilities will be available here soon.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Tools;
